import { render, staticRenderFns } from "./work_add_again.vue?vue&type=template&id=180028cf&scoped=true&"
import script from "./work_add_again.vue?vue&type=script&lang=js&"
export * from "./work_add_again.vue?vue&type=script&lang=js&"
import style0 from "./work_add_again.vue?vue&type=style&index=0&id=180028cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180028cf",
  null
  
)

export default component.exports